import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import PerformanceApi from 'api/executive/performance.api'
import type { GetKeyProceduresParams, KeyProceduresResponse } from 'api/executive/executive.types'

export function useKeyProcedures(limit = 10) {
  return useExecutiveQuery<GetKeyProceduresParams, KeyProceduresResponse>(
    'performance.key-procedures',
    PerformanceApi.getKeyProcedures,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        // intentional: ignore procedureId — widget is a ranking
        limit,
      }
    }
  )
}
